export default "/images/24885d55e809a6127568adf19d3216b8.avif";